<div class="tutorial-container flex justify-center items-center" [@fadeIn]="animationState">
  <div class="tutorial-wrapper flex flex-column items-center" [ngStyle]="{ 'max-width.px': cards.length * 275 }">
    <div class="title bg-color-primary-room w-full text-color-white weight-bold font-l p-8 text-center m-b-16">
      {{ title }}
    </div>

    <!-- Desktop view -->
    <div class="flex gap-8 hide-lt-md">
      @for (card of cards; track card) {
        <div class="flex-1 p-16 flex tutorial-card bg-color-white items-center flex-column">
          <span class="text-center m-b-16">{{ card.title }}</span>
          <div class="flex justify-center items-center flex-1 w-full">
            <img role="presentation" [src]="card.src" />
          </div>
        </div>
      }
    </div>
    @if (customHTML) {
      <div
        class="tutorial-custom-html"
        [innerHTML]="customHTML"
        [ngClass]="{ 'action-menu-is-open': isActionMenuOpen }"
      ></div>
    }
    <button
      class="button text-color-white bg-color-primary-room m-t-16 hide-lt-md"
      matRipple
      data-testid="tutorial-continue-button"
      (click)="onComplete()"
    >
      Continue
    </button>

    <!-- Mobile view -->
    <div class="flex gap-8 w-full hide-gt-sm">
      <div class="flex-1 p-16 flex tutorial-card bg-color-white items-center flex-column">
        <span class="text-center m-b-16">{{ cards[cardIndex].title }}</span>
        <div class="flex justify-center items-center flex-1 w-full">
          <img aria-hidden="true" [src]="cards[cardIndex].src" />
        </div>
        <div class="m-18 flex gap-10">
          @for (card of cards; track card; let i = $index) {
            <div class="card-indicator" [class.bg-color-grey-700]="i === cardIndex"></div>
          }
        </div>
        @if (showSkip) {
          <button matRipple class="link-button" data-testid="tutorial-mobile-skip-button" (click)="onComplete()">
            Skip Tutorial
          </button>
        }
      </div>
    </div>
    <button
      class="button hide-gt-sm button-mobile text-color-white bg-color-primary-room m-t-16"
      matRipple
      data-testid="tutorial-mobile-next-button"
      (click)="onMobileButtonClicked()"
    >
      {{ isLastCard() ? 'Exit' : 'Next' }}
    </button>
  </div>
</div>
